import React from 'react';
import DetailList from 'Views/Page/Content/Templates/DetailList';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { makeStyles } from '@material-ui/core';
import useMobileLayout from 'Hooks/useMobileLayout';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  buttonOuterContainer: {
    position: 'absolute',
    top: theme.spacing(2.5),
    width: '100%',
  },
  buttonOuterContainerMobile: {
    position: 'static',
    top: 0,
    width: '100%',
    margin: 'auto',
    maxWidth: theme.dimensions.md,
  },
  buttonInnerContainer: {
    margin: 'auto',
    width: theme.dimensions.lg,
  },
  buttonInnerContainerMobile: {
    position: 'relative',
    top: theme.spacing(4),
    width: '100%',
  },
  backButton: {
    marginLeft: theme.spacing(1.5),
  },
}));

const AccountOpeningAgreementTemplate = (props) => {
  const classes = useStyles();
  const isMobile = useMobileLayout();

  return (
    <div>
      <div
        className={classNames(classes.buttonOuterContainer, {
          [classes.buttonOuterContainerMobile]: isMobile,
        })}
      >
        <div
          className={classNames(classes.buttonInnerContainer, {
            [classes.buttonInnerContainerMobile]: isMobile,
          })}
        >
          <IconButton component={Link} to="/" className={classes.backButton} aria-label="go back button" size="large">
            <ArrowBackIcon fontSize="inherit" />
          </IconButton>
        </div>
      </div>
      <DetailList {...props} />
    </div>
  );
};

export default AccountOpeningAgreementTemplate;
